/** Audience-first summaries shared by server-rendered heads and client SEO. */
export const META_DESCRIPTIONS = {
  home: {
    en: "AGAPE helps SMEs grow B2B sales without hiring more people. Combine LinkedIn and email sales, AI agents and automation to find opportunities and scale delivery.",
    pl: "AGAPE pomaga MŚP zwiększać sprzedaż B2B bez powiększania zespołu. Połącz sprzedaż przez LinkedIn i e-mail, agentów AI oraz automatyzację, by zdobywać klientów.",
    by: "AGAPE дапамагае МСП павялічваць B2B-продажы без найму новых людзей. Аб'яднайце LinkedIn, e-mail, AI-агентаў і аўтаматызацыю для пошуку кліентаў.",
  },
  about: {
    en: "Meet the AGAPE team and its Post-Hiring approach: practical AI, sales systems and automation that help SMEs grow without expanding headcount.",
    pl: "Poznaj zespół AGAPE i podejście Post-Hiring: praktyczne AI, systemy sprzedaży i automatyzacja, które pomagają MŚP rosnąć bez powiększania zespołu.",
    by: "Пазнаёмцеся з камандай AGAPE і падыходам Post-Hiring: практычны AI, сістэмы продажаў і аўтаматызацыя для росту МСП без павелічэння штату.",
  },
  agent: {
    en: "Paste your marketing copy and get instant feedback from an AI target persona. Spot weak messaging and improve relevance before publishing—free, no sign-up.",
    pl: "Wklej tekst marketingowy i odbierz szybką opinię persony AI. Wykryj słabe punkty komunikacji i popraw jej trafność przed publikacją — bezpłatnie, bez rejestracji.",
    by: "Устаўце маркетынгавы тэкст і атрымайце хуткі водгук AI-персоны. Знайдзіце слабыя месцы ў камунікацыі да публікацыі — бясплатна, без рэгістрацыі.",
  },
  contact: {
    en: "Book a 25-minute AGAPE Discovery Call about your sales and automation challenges. Assess fit and identify a practical next step for your business.",
    pl: "Umów 25-minutową rozmowę z AGAPE o sprzedaży i automatyzacji w Twojej firmie. Sprawdźmy, czy pasujemy do siebie i jaki kolejny krok ma sens.",
    by: "Запішыцеся на 25-хвілінную размову з AGAPE пра продажы і аўтаматызацыю. Ацаніце, ці падыходзім мы адно аднаму, і вызначце наступны крок.",
  },
  marketing: {
    en: "Compare AGAPE Octopus, PersonaFi, Researcher and Liberty: B2B sales automation, message validation, market research and AI search visibility for SMEs.",
    pl: "Porównaj Octopus, PersonaFi, Researcher i Liberty: automatyzacja sprzedaży B2B, walidacja komunikacji, analiza rynku i widoczność marki w AI dla MŚP.",
    by: "Параўнайце Octopus, PersonaFi, Researcher і Liberty: аўтаматызацыя B2B-продажаў, праверка камунікацыі, аналіз рынку і бачнасць брэнда ў AI.",
  },
  octopus: {
    en: "AGAPE Octopus organizes B2B sales via LinkedIn and email into a repeatable process. Manage follow-ups, cadence and contact data to build a steadier pipeline.",
    pl: "AGAPE Octopus łączy sprzedaż B2B przez LinkedIn i e-mail w powtarzalny proces. Uporządkuj follow-upy, rytm kontaktu i bazę, by rozwijać pipeline.",
    by: "AGAPE Octopus аб'ядноўвае B2B-продажы праз LinkedIn і e-mail у паўтаральны працэс. Упарадкуйце наступныя кантакты і базу, каб развіваць варонку.",
  },
  interim: {
    en: "AGAPE Interim Management gives SMEs an external innovation team: senior expertise, operational support and tools to move initiatives forward without permanent hiring.",
    pl: "Interim Management AGAPE daje MŚP zewnętrzny dział innowacji: strategię seniora, wsparcie operacyjne i narzędzia do wdrażania zmian bez stałej rekrutacji.",
    by: "Interim Management AGAPE дае МСП знешнюю каманду інавацый: стратэгію, аперацыйную працу і інструменты для змен без пастаяннага найму.",
  },
  liberty: {
    en: "AGAPE Liberty helps B2B brands build visibility in AI answers. A 20-agent AEO network plans and produces consistent content for AI-driven discovery.",
    pl: "AGAPE Liberty pomaga markom B2B budować widoczność w odpowiedziach AI. Sieć 20 agentów AEO planuje i tworzy spójne treści dla wyszukiwania z AI.",
    by: "AGAPE Liberty дапамагае B2B-брэндам павялічваць бачнасць у адказах AI. Сетка з 20 AEO-агентаў плануе і стварае паслядоўны кантэнт.",
  },
  personafi: {
    en: "AGAPE PersonaFi checks your personas, messaging and content in about 2 minutes. Get scores, gaps and practical next steps for €1 per validation.",
    pl: "AGAPE PersonaFi sprawdza persony, komunikację i treści w około 2 minuty. Otrzymaj oceny, luki i konkretne wskazówki za 1 € za walidację.",
    by: "AGAPE PersonaFi правярае персоны, камунікацыю і кантэнт прыкладна за 2 хвіліны. Атрымайце ацэнкі, прабелы і рэкамендацыі за 1 €.",
  },
  researcher: {
    en: "AGAPE Researcher gives SME leaders a strategic report in about 15 minutes: AI SWOT, competitor battlecard and brand visibility analysis for better decisions.",
    pl: "AGAPE Researcher daje liderom MŚP raport strategiczny w około 15 minut: AI-SWOT, analizę konkurencji i widoczności marki dla lepszych decyzji.",
    by: "AGAPE Researcher дае кіраўнікам МСП стратэгічную справаздачу прыкладна за 15 хвілін: AI-SWOT, аналіз канкурэнтаў і бачнасці брэнда.",
  },
  spotless: {
    en: "Spotless Polska case study: how AGAPE built a new brand and B2B email campaigns that reached 385 companies, with a 9.9% reply rate and 4 quote requests.",
    pl: "Case study Spotless Polska: jak AGAPE zbudowało nową markę i kampanie e-mail B2B, które dotarły do 385 firm, z 9,9% odpowiedzi i 4 zapytaniami ofertowymi.",
    by: "Кейс Spotless Polska: як AGAPE стварыла новую марку і B2B e-mail-кампаніі, што ахапілі 385 фірмаў, з 9,9% адказаў і 4 запытамі.",
  },
  blog: {
    en: "Read practical AGAPE guides on B2B sales, AI visibility, marketing and automation. Find tactics and decision frameworks for growing an SME without extra hires.",
    pl: "Czytaj praktyczne poradniki AGAPE o sprzedaży B2B, widoczności w AI, marketingu i automatyzacji. Znajdź wskazówki dla MŚP rosnących bez rekrutacji.",
    by: "Чытайце практычныя матэрыялы AGAPE пра B2B-продажы, бачнасць у AI, маркетынг і аўтаматызацыю для росту МСП без дадатковага найму.",
  },
} as const;

type MetaPage = keyof typeof META_DESCRIPTIONS;
type MetaLanguage = "en" | "pl" | "by";

const PATH_PAGES: Record<string, MetaPage> = {
  "/": "home",
  "/about-us": "about",
  "/agent": "agent",
  "/contact": "contact",
  "/marketing-sales": "marketing",
  "/octopus": "octopus",
  "/interim-management": "interim",
  "/liberty": "liberty",
  "/personaFi": "personafi",
  "/researcher": "researcher",
  "/blog": "blog",
  "/case-studies/spotless-polska": "spotless",
};

/** Keep the client-updated description identical to the route's SSR description. */
export function pageMetaDescription(path: string, fallback: string): string {
  let pathname: string;
  try {
    pathname = new URL(path, "https://agapeco.net").pathname;
  } catch {
    return fallback;
  }
  const parts = pathname.replace(/\/$/, "").split("/");
  const language: MetaLanguage = parts[1] === "pl" || parts[1] === "by" ? parts[1] : "en";
  const localPath = (language === "en" ? pathname : `/${parts.slice(2).join("/")}`).replace(/\/$/, "") || "/";
  const page = PATH_PAGES[localPath];
  return page ? META_DESCRIPTIONS[page][language] : fallback;
}